import React from 'react';

export interface CircleListLineProps {
  className?: string;
  type?: string;
  variant?: string;
}

export const CircleListLine: React.FC<CircleListLineProps> = ({
  className = '',
  type = 'left',
  variant = 'straight',
  ...props
}) => {
  if (type == 'left' && variant == 'curved') {
    return (
      <svg
        width={294}
        height={81}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M1 1.616c90.442 41.027 188.733 67.785 292 77.4"
          stroke="url(#prefix__paint0_linear)"
          strokeLinecap="round"
          strokeDasharray="1 4"
        />
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={87.129}
            y1={1.616}
            x2={212.049}
            y2={123.74}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#36DC90" />
            <stop stopColor="#36DC90" />
            <stop offset={1} stopColor="#CEB9F3" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (type == 'right' && variant == 'curved') {
    return (
      <svg
        width={294}
        height={81}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M293 1.616c-90.442 41.027-188.733 67.785-292 77.4"
          stroke="url(#prefix__paint0_linear)"
          strokeLinecap="round"
          strokeDasharray="1 4"
        />
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={206.871}
            y1={1.616}
            x2={81.951}
            y2={123.74}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#36DC90" />
            <stop stopColor="#36DC90" />
            <stop offset={1} stopColor="#CEB9F3" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      width={268}
      height={2}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.5 1H267"
        stroke="#B2C0E1"
        strokeLinecap="round"
        strokeDasharray="1 4"
      />
    </svg>
  );
};
